import {axiosReactClient} from '../axios';

export async function setVk(viewKey: string) {
  const {data} = await axiosReactClient.post<{
    viewKey: string;
  }>(`/view-key/`, {viewKey});
  return data;
}

export async function removeVk() {
  const {data} = await axiosReactClient.delete<{
    viewKey: string;
  }>(`/view-key/`);
  return data;
}
